export class ZeroLine {
    constructor(ctrlr, yParameter, colour) {
        this.ctrlr = ctrlr;
        this.yParameter = yParameter;
        this.colour = colour;
    }
    draw(data) {
        // const yParameter = this.ctrlr.parameters[this.yParameter] != undefined ? this.ctrlr.parameters[this.yParameter] : this.yParameter;
        this.line = this.ctrlr.svg.layers.data.selectAll('.line-' + this.yParameter)
            .data([data])
            .join("path")
            .attr("class", "line-" + this.yParameter);
    }
    lineMaker() {
        return window.d3.line()
            .x(d => this.ctrlr.scales.x.scale(0))
            .y((d, i) => {
            return this.ctrlr.scales.y.scale(d);
        })
            .curve(window.d3.curveBasis);
    }
    redraw() {
        let self = this;
        this.line
            .transition()
            .duration(500)
            .attr("d", 'M ' + this.ctrlr.scales.x.scale(0) + ' 0 V ' + this.ctrlr.dimensions.height)
            .attr("fill", 'transparent')
            .attr("stroke", d => this.colour)
            .attr("stroke-width", 1);
    }
}
